module.exports = __webpack_public_path__ + "img/test-detector.fa9460c0.svg";